const requireContext = require.context(".", true, /\.(js|jsx|tsx)$/);

requireContext.keys().forEach(requireContext);
